import React, { Component } from 'react'
import { connect } from 'react-redux'
import Modal from 'react-modal'
import * as properties from '../../constants/Properties'
import { setInvoiceInfoModal } from '../actions/modalActions'
import { getTranslation } from '../../actions/dataActions'
import PropTypes from 'prop-types'
import * as resource from '../../constants/Resources'

class SetInvoiceInfoModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            originalInvoiceNumber: '',
            reference: ''
        };

        this.cancelTap = this.cancelTap.bind(this);
        this.confirmTap = this.confirmTap.bind(this);
        this.handleOriginalInvoiceNumberChange = this.handleOriginalInvoiceNumberChange.bind(this);
        this.handleReferenceChange = this.handleReferenceChange.bind(this);
        this.keyPressed = this.keyPressed.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.invoiceInfoModal.show && !this.props.invoiceInfoModal.show) {
            this.setState({ originalInvoiceNumber: '', reference: '' });
        }
    }

    cancelTap() {
        this.props.setInvoiceInfoModal(false, false, null, [], null);
        this.setState({ originalInvoiceNumber: '', reference: '' });
    }

    confirmTap() {
        const { originalInvoiceNumber, reference } = this.state;

        const callback = this.props.invoiceInfoModal.callback;
        const dispatch = this.props.invoiceInfoModal.dispatch;

        let callbackParams = [originalInvoiceNumber.trim(), reference.trim()];

        if (this.props.invoiceInfoModal.callbackparams) {
            this.props.invoiceInfoModal.callbackparams.forEach(param => {
                callbackParams.push(param);
            });
        }

        if (callback !== null && callback !== undefined) {
            if (dispatch !== null && dispatch !== undefined) {
                dispatch(callback.apply(this, callbackParams));
            } else {
                callback.apply(this, callbackParams);
            }
        }
    }

    keyPressed(event) {
        if (event.key === 'Enter') {
            this.confirmTap();
        }
    }

    handleOriginalInvoiceNumberChange(event) {
        this.setState({ originalInvoiceNumber: event.target.value });
    }

    handleReferenceChange(event) {
        this.setState({ reference: event.target.value });
    }

    render() {
        return (
            <Modal
                className="inputModal"
                contentLabel=""
                isOpen={!!this.props.invoiceInfoModal.show}
                style={properties.inputModalStyle}
            >
                <div className="inputModal_header">
                    <div className="header_top">
                        {this.props.getTranslation(resource.TO_INVOICE)}
                    </div>
                </div>
                <div className="inputModal_content">
                    {this.props.invoiceInfoModal.isCredit && <label className="inputModal_label">
                        {this.props.getTranslation(resource.ORIGINAL_INVOICE_NUMBER)}
                    </label>}
                    {this.props.invoiceInfoModal.isCredit && <input
                        className="inputModal_input"
                        type="text"
                        value={this.state.originalInvoiceNumber}
                        placeholder={this.props.getTranslation(resource.ENTER_ORIGINAL_INVOICE_NUMBER)}
                        onChange={this.handleOriginalInvoiceNumberChange}
                        onKeyPress={this.keyPressed}
                        autoFocus={true}
                    />}
                    <label className="inputModal_label">
                        {this.props.getTranslation(resource.INVOICE_REFERENCE)}
                    </label>
                    <input
                        className="inputModal_input"
                        type="text"
                        value={this.state.reference}
                        placeholder={this.props.getTranslation(resource.INVOICE_REFERENCE_INPUT_MESSAGE)}
                        onChange={this.handleReferenceChange}
                        onKeyPress={this.keyPressed}
                        autoFocus={!this.props.invoiceInfoModal.isCredit}
                    />
                </div>
                <div className="inputModal_footer">
                    <button className="btnCancel" onClick={this.cancelTap}>
                        {this.props.getTranslation(resource.CANCEL)}
                    </button>
                    <button className="btnApprove" onClick={this.confirmTap}>
                        {this.props.getTranslation(resource.SAVE)}
                    </button>
                </div>
            </Modal>
        );
    }
}

SetInvoiceInfoModal.propTypes = {
    invoiceInfoModal: PropTypes.object.isRequired,
    setInvoiceInfoModal: PropTypes.func.isRequired,
    getTranslation: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {
        invoiceInfoModal: state.modalState.invoiceInfoModal
    };
}

export default connect(mapStateToProps, {
    setInvoiceInfoModal,
    getTranslation
})(SetInvoiceInfoModal);



// WEBPACK FOOTER //
// src/modal/components/SetInvoiceInfoModal.jsx